import * as React from "react";
import {
  Layout,
  Metatags,
  Header,
  Home,
  ClientsReview,
  Qualify,
  AsSeenOn,
  HighIncome,
  Footer,
} from "@ADC/components/Views";
import Steps from "@ADC/components/Pages/Home/Form-2/Steps";
import FAQs from "@ADC/components/Views/faqs";
import { Link } from "gatsby";

const MainPage = () => {
  const stickyRef = React.useRef(null);
  const [isSticky, setIsSticky] = React.useState(false);

  React.useEffect(() => {
    const handleScroll = () => {
      const rect = stickyRef?.current?.getBoundingClientRect();

      setIsSticky(rect?.bottom < window.innerHeight);
    };

    window.addEventListener("scroll", handleScroll);
  }, []);

  return (
    <React.Fragment>
      <Layout className="w-full h-full pt-[85px] lg:pt-32 desktop:pt-[150px] overflow-x-hidden max-sm:mb-9">
        <Header />
        <Home />

        <div className="max-sm:hidden">
          <Steps />
        </div>
        <HighIncome />

        <div ref={stickyRef}>
          <ClientsReview />
        </div>

        {isSticky && (
          <div className="bg-white flex items-center gap-3 px-3 py-5 fixed inset-x-0 bottom-0 z-40 sm:hidden">
            <a
              className="text-white bg-green-700 transition hover:bg-green-800 px-2 py-1.5 rounded-lg font-bold text-xl"
              href="tel:8008161003"
            >
              Call Us
            </a>
            <Link to="/apply/">
              <button className="text-sky-700 border-2 border-sky-700 transition hover:bg-sky-800 hover:text-white px-2 py-1.5 rounded-lg font-bold text-xl">
                See if you qualify
              </button>
            </Link>
          </div>
        )}
        <Qualify />
        <AsSeenOn />
        <FAQs />
        <Footer />
      </Layout>

      {/* <div className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full z-50">
        <div className="w-full h-screen flex items-center justify-center bg-[#00000080]">
          <div className="w-[450px] border rounded-3xl bg-white text-center p-12">
            <img
              src="https://cdn-jnjbn.nitrocdn.com/GWDIEzxFkLCKQMTJOvFMAOCVLqdGBlyP/assets/images/optimized/rev-ba470dd/www.nationaldebtrelief.com/wp-content/uploads/2022/04/affordable-plan.svg"
              className="mx-auto"
              alt=""
            />
            <h2 className="text-3xl font-semibold capitalize my-5">
              can you imagine life without debt?
            </h2>
            <p className="text-xl leading-8">
              Take the next step to live the future you envision. Download your
              FREE guide to get started.
            </p>
            <input
              type="email"
              className="my-8 w-full border font-medium border-black px-4 py-3 rounded"
              placeholder="Email Address"
            />
            <button className="bg-blue-600 text-white py-3 font-bold rounded-3xl w-full text-center">
              Let's Do this
            </button>
          </div>
        </div>
      </div> */}
    </React.Fragment>
  );
};

export default MainPage;

export const Head = () => <Metatags />;
